import * as React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import { AppProvider } from "@toolpad/core/AppProvider";
import { SignInPage } from "@toolpad/core/SignInPage";
import { useTheme } from "@mui/material/styles";
import { signInWithFacebook } from "../authMethods/signInWithFacebook"; 
import { signInWithGoogle } from "../authMethods/signInWithGoogle"; 

// Define available providers
const providers = [
  { id: "google", name: "Google" },
  { id: "facebook", name: "Facebook" },
];

export default function OAuthSignInPage({ onBack }) {
  const theme = useTheme();
  const navigate = useNavigate(); // Hook for navigation

  // Main sign-in function
  const signIn = async (provider) => {
    try {
      let user;
      switch (provider.id) {
        case "google":
          user = await signInWithGoogle();
          console.log("Google sign-in successful!", user);
          break;
        case "facebook":
          user = await signInWithFacebook();
          console.log("Facebook sign-in successful!", user);
          break;
        default:
          console.log(`Sign in with ${provider.name} is not implemented`);
          return;
      }
      
      if (user) {
        // Redirect to the main page
        navigate("/main"); // Replace "/main" with your desired route
      }
    } catch (error) {
      console.error(`Error during ${provider.name} sign-in:`, error);
    }
  };

  return (
    <AppProvider theme={theme}>
      <SignInPage signIn={signIn} providers={providers} />
    </AppProvider>
  );
}
